import React from 'react';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';

import {Topbar} from './components';
import {SCRN_PATCH_NOTES} from 'src/Routes/screens';
import {Box} from '@mui/material';

const useStyles = makeStyles()(theme => ({
   root: {
      paddingTop: '64px',
      height: '100%'
   },
   content: {
      height: '100%'
   }
}));

const Minimal = props => {
   const {children} = props;
   const {classes} = useStyles();
   const {pathname} = useLocation();
   if (pathname.includes(`${SCRN_PATCH_NOTES.path}/`)) {
      return (
         <Box component="main" className={classes.content}>
            {children}
         </Box>
      );
   }
   return (
      <Box className={classes.root}>
         <Topbar />
         <Box component="main" className={classes.content}>
            {children}
         </Box>
      </Box>
   );
};

Minimal.propTypes = {
   children: PropTypes.node,
   sx: PropTypes.string
};

export default Minimal;
